export default "__VITE_ASSET__efcf37b4__"